export enum QuestionType {
  Test = 1,
  WrittenAnswer = 2,
  Essay = 3,
}
